import { create } from "zustand";
import { toast } from "react-toastify";

/* =====================
   TYPES
===================== */
export type BasicProfilePayload = {
  photo?: File | null;
  name: string;
  phone: string;
  birth_date: string;
  gender_id: number;
  country_id: number;
  state_id: number;
  city_id: number;
  martial_status_id?: number;
  degree_id?: number;
  about: string;
  experience_year_id: number;
  experience_level_id: number;
};

/* =====================
   TOKEN
===================== */
const getAccessToken = (): string | null => {
  try {
    const raw = localStorage.getItem("auth-storage");
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.state?.accessToken || null;
  } catch {
    return null;
  }
};

/* =====================
   STORE
===================== */
type BasicProfileState = {
  loading: boolean;
  updateBasicProfile: (payload: BasicProfilePayload) => Promise<boolean>;
};

export const useBasicProfileStore = create<BasicProfileState>((set) => ({
  loading: false,

  updateBasicProfile: async (payload) => {
    try {
      set({ loading: true });

      const token = getAccessToken();
      if (!token) throw new Error("No token");

      const formData = new FormData();

      // ⚠️ KEY HARUS PERSIS SAMA API
      if (payload.photo instanceof File) {
        formData.append("photo", payload.photo);
      }

      formData.append("name", payload.name);
      formData.append("phone", payload.phone);
      formData.append("birth_date", payload.birth_date);
      formData.append("gender_id", String(payload.gender_id));
      formData.append("country_id", String(payload.country_id));
      formData.append("degree_id", String(payload.degree_id));
      formData.append("state_id", String(payload.state_id));
      formData.append("city_id", String(payload.city_id));

      if (payload.martial_status_id) {
        formData.append(
          "martial_status_id",
          String(payload.martial_status_id)
        );
      }

      formData.append("about", payload.about);
      formData.append(
        "experience_year_id",
        String(payload.experience_year_id)
      );
      formData.append(
        "experience_level_id",
        String(payload.experience_level_id)
      );

      const res = await fetch(
        "https://admin-talentlink.digiline.id/api/candidate/basic-profile",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            // ❌ JANGAN SET Content-Type
          },
          body: formData,
        }
      );

      if (!res.ok) {
        const err = await res.text();
        console.error("API ERROR:", err);
        throw new Error("Update basic profile failed");
      }

      toast.success("Basic profile updated");
      return true;
    } catch (e) {
      console.error(e);
      toast.error("Failed to update basic profile");
      return false;
    } finally {
      set({ loading: false });
    }
  },
}));
